import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Chart({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Chart.Outline {...props} /> : <Chart.Solid {...props} />;
}

Chart.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M11.5381 5.66919C11.5381 5.25498 11.2023 4.91919 10.7881 4.91919C10.3739 4.91919 10.0381 5.25498 10.0381 5.66919V15.8119C10.0381 16.2261 10.3739 16.5619 10.7881 16.5619C11.2023 16.5619 11.5381 16.2261 11.5381 15.8119V5.66919Z"
          fill="currentColor"
        />
        <path
          d="M6.87134 8.95166C6.87134 8.53745 6.53555 8.20166 6.12134 8.20166C5.70712 8.20166 5.37134 8.53745 5.37134 8.95166V15.8118C5.37134 16.226 5.70712 16.5618 6.12134 16.5618C6.53555 16.5618 6.87134 16.226 6.87134 15.8118V8.95166Z"
          fill="currentColor"
        />
        <path
          d="M15.3787 11.8269C15.7929 11.8269 16.1287 12.1627 16.1287 12.5769V15.8119C16.1287 16.2261 15.7929 16.5619 15.3787 16.5619C14.9644 16.5619 14.6287 16.2261 14.6287 15.8119V12.5769C14.6287 12.1627 14.9644 11.8269 15.3787 11.8269Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.06429 0C4.24524 0 2.71018 0.648836 1.63354 1.80377C0.562353 2.95285 0 4.54292 0 6.33516V15.1648C0 16.9562 0.559425 18.5464 1.62964 19.6959C2.7055 20.8515 4.24096 21.5 6.06429 21.5H15.4357C17.259 21.5 18.7945 20.8515 19.8704 19.6959C20.9406 18.5464 21.5 16.9562 21.5 15.1648V6.33516C21.5 4.54384 20.9406 2.95365 19.8704 1.80412C18.7945 0.648535 17.259 0 15.4357 0H6.06429ZM1.5 6.33516C1.5 4.85432 1.96146 3.65181 2.73074 2.82659C3.49458 2.00721 4.61666 1.5 6.06429 1.5H15.4357C16.8886 1.5 18.0103 2.00751 18.7725 2.82623C19.5404 3.65101 20 4.8534 20 6.33516V15.1648C20 16.6466 19.5404 17.849 18.7725 18.6738C18.0103 19.4925 16.8886 20 15.4357 20H6.06429C4.61142 20 3.48974 19.4925 2.7275 18.6738C1.95962 17.849 1.5 16.6466 1.5 15.1648V6.33516Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Chart.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-secondary"
          d="M16.7874 2.72119H7.44515C4.04071 2.72119 2.11182 4.65008 2.11182 8.05452V17.3879C2.11182 20.7923 4.04071 22.7212 7.44515 22.7212H16.7874C20.1918 22.7212 22.1118 20.7923 22.1118 17.3879V8.05452C22.1118 4.65008 20.1918 2.72119 16.7874 2.72119Z"
        />
        <path
          className="icon-primary"
          d="M7.48048 10.0902C7.02714 10.0902 6.65381 10.4635 6.65381 10.9257V17.7968C6.65381 18.2502 7.02714 18.6235 7.48048 18.6235C7.9427 18.6235 8.31603 18.2502 8.31603 17.7968V10.9257C8.31603 10.4635 7.9427 10.0902 7.48048 10.0902Z"
        />
        <path
          className="icon-primary"
          d="M12.147 6.81017C11.6936 6.81017 11.3203 7.1835 11.3203 7.64572V17.7968C11.3203 18.2502 11.6936 18.6235 12.147 18.6235C12.6092 18.6235 12.9825 18.2502 12.9825 17.7968V7.64572C12.9825 7.1835 12.6092 6.81017 12.147 6.81017Z"
        />
        <path
          className="icon-primary"
          d="M16.7516 13.7168C16.2893 13.7168 15.916 14.0902 15.916 14.5524V17.7968C15.916 18.2502 16.2893 18.6235 16.7427 18.6235C17.2049 18.6235 17.5782 18.2502 17.5782 17.7968V14.5524C17.5782 14.0902 17.2049 13.7168 16.7516 13.7168Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
